module.exports = __webpack_public_path__ + "static/media/de.a37705d1.png";